var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "calculator" }, [
    _vm.fields.deck_platform.title
      ? _c("div", [
          _c("h2", { staticClass: "font-h4" }, [
            _vm._v(_vm._s(_vm.fields.deck_platform.title)),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.fields.deck_platform.description))]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.fields.deck_platform.title
      ? _c(
          "div",
          { staticClass: "range-wrapper" },
          [
            _c("div", { staticClass: "caption" }, [
              _vm._v("Enter Platform Size (sq. feet)"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "min" }, [
              _vm._v(
                "Min. " + _vm._s(_vm.fields.deck_platform.min) + " sq. feet"
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "max" }, [
              _vm._v(
                "Max. " + _vm._s(_vm.fields.deck_platform.max) + " sq. feet"
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.values.platform_size) + " sq. feet"),
            ]),
            _vm._v(" "),
            _c("delta-range-slider", {
              attrs: {
                min: _vm.fields.deck_platform.min,
                max: _vm.fields.deck_platform.max,
              },
              model: {
                value: _vm.values.platform_size,
                callback: function ($$v) {
                  _vm.$set(_vm.values, "platform_size", $$v)
                },
                expression: "values.platform_size",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "options-wrapper" },
      [
        _vm._l(_vm.fields.deck_platform.materials, function (material, index) {
          return [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.values.material,
                  expression: "values.material",
                },
              ],
              staticStyle: { display: "none" },
              attrs: {
                type: "radio",
                name: "deck_material",
                id: "deck_material_" + index,
              },
              domProps: {
                value: index,
                checked: _vm._q(_vm.values.material, index),
              },
              on: {
                change: function ($event) {
                  return _vm.$set(_vm.values, "material", index)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "option option--radio",
                attrs: { for: "deck_material_" + index },
              },
              [
                _c("span", { staticClass: "center" }, [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(material.title)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "description" }, [
                    _vm._v(_vm._s(material.description)),
                  ]),
                ]),
                _vm._v(" "),
                _c("img", {
                  attrs: { src: material.image, alt: material.title },
                }),
              ]
            ),
          ]
        }),
      ],
      2
    ),
    _vm._v(" "),
    _vm.fields.deck_elevation.title
      ? _c("div", [
          _c("h2", { staticClass: "font-h4" }, [
            _vm._v(_vm._s(_vm.fields.deck_elevation.title)),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.fields.deck_elevation.description))]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.fields.deck_elevation.title
      ? _c(
          "div",
          { staticClass: "range-wrapper" },
          [
            _c("div", { staticClass: "caption" }, [
              _vm._v("Enter Average Deck Height (feet)"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "min" }, [
              _vm._v("Min. " + _vm._s(_vm.fields.deck_elevation.min) + " feet"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "max" }, [
              _vm._v("Max. " + _vm._s(_vm.fields.deck_elevation.max) + " feet"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.values.elevation_size) + " feet"),
            ]),
            _vm._v(" "),
            _c("delta-range-slider", {
              attrs: {
                min: _vm.fields.deck_elevation.min,
                max: _vm.fields.deck_elevation.max,
              },
              model: {
                value: _vm.values.elevation_size,
                callback: function ($$v) {
                  _vm.$set(_vm.values, "elevation_size", $$v)
                },
                expression: "values.elevation_size",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.fields.deck_railing.title
      ? _c("div", [
          _c("h2", { staticClass: "font-h4" }, [
            _vm._v(_vm._s(_vm.fields.deck_railing.title)),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.fields.deck_railing.description))]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.fields.deck_railing.title
      ? _c(
          "div",
          { staticClass: "range-wrapper" },
          [
            _c("div", { staticClass: "caption" }, [
              _vm._v("Enter Total Length Of Railing (feet)"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "min" }, [
              _vm._v("Min. " + _vm._s(_vm.fields.deck_railing.min) + " feet"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "max" }, [
              _vm._v("Max. " + _vm._s(_vm.fields.deck_railing.max) + " feet"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.values.railing_size) + " feet"),
            ]),
            _vm._v(" "),
            _c("delta-range-slider", {
              attrs: {
                min: _vm.fields.deck_railing.min,
                max: _vm.fields.deck_railing.max,
              },
              model: {
                value: _vm.values.railing_size,
                callback: function ($$v) {
                  _vm.$set(_vm.values, "railing_size", $$v)
                },
                expression: "values.railing_size",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "options-wrapper" },
      [
        _vm._l(_vm.fields.deck_railing.materials, function (material, index) {
          return [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.values.railing,
                  expression: "values.railing",
                },
              ],
              staticStyle: { display: "none" },
              attrs: {
                type: "radio",
                name: "deck_railing",
                id: "deck_railing_" + index,
              },
              domProps: {
                value: index,
                checked: _vm._q(_vm.values.railing, index),
              },
              on: {
                change: function ($event) {
                  return _vm.$set(_vm.values, "railing", index)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "option option--radio",
                attrs: { for: "deck_railing_" + index },
              },
              [
                _c("span", { staticClass: "center" }, [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(material.title)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "description" }, [
                    _vm._v(_vm._s(material.description)),
                  ]),
                ]),
                _vm._v(" "),
                _c("img", {
                  attrs: { src: material.image, alt: material.title },
                }),
              ]
            ),
          ]
        }),
      ],
      2
    ),
    _vm._v(" "),
    _vm.fields.deck_privacy_wall.title
      ? _c("div", [
          _c("h2", { staticClass: "font-h4" }, [
            _vm._v(_vm._s(_vm.fields.deck_privacy_wall.title)),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.fields.deck_privacy_wall.description))]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.fields.deck_privacy_wall.title
      ? _c(
          "div",
          { staticClass: "range-wrapper" },
          [
            _c("div", { staticClass: "caption" }, [
              _vm._v("Enter Total Length Of Railing (feet)"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "min" }, [
              _vm._v(
                "Min. " + _vm._s(_vm.fields.deck_privacy_wall.min) + " feet"
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "max" }, [
              _vm._v(
                "Max. " + _vm._s(_vm.fields.deck_privacy_wall.max) + " feet"
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.values.privacy_wall_size) + " feet"),
            ]),
            _vm._v(" "),
            _c("delta-range-slider", {
              attrs: {
                min: _vm.fields.deck_privacy_wall.min,
                max: _vm.fields.deck_privacy_wall.max,
              },
              model: {
                value: _vm.values.privacy_wall_size,
                callback: function ($$v) {
                  _vm.$set(_vm.values, "privacy_wall_size", $$v)
                },
                expression: "values.privacy_wall_size",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "options-wrapper" },
      [
        _vm._l(
          _vm.fields.deck_privacy_wall.materials,
          function (material, index) {
            return [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.values.privacy_wall,
                    expression: "values.privacy_wall",
                  },
                ],
                staticStyle: { display: "none" },
                attrs: {
                  type: "radio",
                  name: "deck_privacy_wall",
                  id: "deck_privacy_wall_" + index,
                },
                domProps: {
                  value: index,
                  checked: _vm._q(_vm.values.privacy_wall, index),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.values, "privacy_wall", index)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "option option--radio",
                  attrs: { for: "deck_privacy_wall_" + index },
                },
                [
                  _c("span", { staticClass: "center" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(material.title)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "description" }, [
                      _vm._v(_vm._s(material.description)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    attrs: { src: material.image, alt: material.title },
                  }),
                ]
              ),
            ]
          }
        ),
      ],
      2
    ),
    _vm._v(" "),
    _vm.fields.deck_number_of_stairs.title
      ? _c("div", [
          _c("h2", { staticClass: "font-h4" }, [
            _vm._v(_vm._s(_vm.fields.deck_number_of_stairs.title)),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(_vm._s(_vm.fields.deck_number_of_stairs.description)),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.fields.deck_number_of_stairs.title
      ? _c(
          "div",
          { staticClass: "range-wrapper" },
          [
            _c("div", { staticClass: "caption" }, [
              _vm._v(
                'Enter the number of your stairs (assume 42" length, material matching decking)'
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "min" }, [
              _vm._v(
                "Min. " +
                  _vm._s(_vm.fields.deck_number_of_stairs.min) +
                  " stairs"
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "max" }, [
              _vm._v(
                "Max. " +
                  _vm._s(_vm.fields.deck_number_of_stairs.max) +
                  " stairs"
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.values.number_of_stairs) + " stairs"),
            ]),
            _vm._v(" "),
            _c("delta-range-slider", {
              attrs: {
                min: _vm.fields.deck_number_of_stairs.min,
                max: _vm.fields.deck_number_of_stairs.max,
              },
              model: {
                value: _vm.values.number_of_stairs,
                callback: function ($$v) {
                  _vm.$set(_vm.values, "number_of_stairs", $$v)
                },
                expression: "values.number_of_stairs",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.fields.deck_options.title
      ? _c("div", [
          _c("h2", { staticClass: "font-h4" }, [
            _vm._v(_vm._s(_vm.fields.deck_options.title)),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.fields.deck_options.description))]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "options-wrapper" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.values.options.deck_permit,
            expression: "values.options.deck_permit",
          },
        ],
        staticStyle: { display: "none" },
        attrs: { type: "checkbox", id: "deck_option_1" },
        domProps: {
          checked: Array.isArray(_vm.values.options.deck_permit)
            ? _vm._i(_vm.values.options.deck_permit, null) > -1
            : _vm.values.options.deck_permit,
        },
        on: {
          change: function ($event) {
            var $$a = _vm.values.options.deck_permit,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 &&
                  _vm.$set(_vm.values.options, "deck_permit", $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  _vm.$set(
                    _vm.values.options,
                    "deck_permit",
                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                  )
              }
            } else {
              _vm.$set(_vm.values.options, "deck_permit", $$c)
            }
          },
        },
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "option option--checkbox",
          attrs: { for: "deck_option_1" },
        },
        [
          _c("span", { staticClass: "center" }, [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.fields.deck_options.deck_permit.title)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "description" }, [
              _vm._v(_vm._s(_vm.fields.deck_options.deck_permit.description)),
            ]),
          ]),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: _vm.fields.deck_options.deck_permit.image,
              alt: _vm.fields.deck_options.deck_permit.title,
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.values.options.basic_lights_package,
            expression: "values.options.basic_lights_package",
          },
        ],
        staticStyle: { display: "none" },
        attrs: { type: "checkbox", id: "deck_option_2" },
        domProps: {
          checked: Array.isArray(_vm.values.options.basic_lights_package)
            ? _vm._i(_vm.values.options.basic_lights_package, null) > -1
            : _vm.values.options.basic_lights_package,
        },
        on: {
          change: function ($event) {
            var $$a = _vm.values.options.basic_lights_package,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 &&
                  _vm.$set(
                    _vm.values.options,
                    "basic_lights_package",
                    $$a.concat([$$v])
                  )
              } else {
                $$i > -1 &&
                  _vm.$set(
                    _vm.values.options,
                    "basic_lights_package",
                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                  )
              }
            } else {
              _vm.$set(_vm.values.options, "basic_lights_package", $$c)
            }
          },
        },
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "option option--checkbox",
          attrs: { for: "deck_option_2" },
        },
        [
          _c("span", { staticClass: "center" }, [
            _c("span", { staticClass: "title" }, [
              _vm._v(
                _vm._s(_vm.fields.deck_options.basic_lights_package.title)
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "description" }, [
              _vm._v(
                _vm._s(_vm.fields.deck_options.basic_lights_package.description)
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: _vm.fields.deck_options.basic_lights_package.image,
              alt: _vm.fields.deck_options.basic_lights_package.title,
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.values.options.deck_skirting,
            expression: "values.options.deck_skirting",
          },
        ],
        staticStyle: { display: "none" },
        attrs: { type: "checkbox", id: "deck_option_3" },
        domProps: {
          checked: Array.isArray(_vm.values.options.deck_skirting)
            ? _vm._i(_vm.values.options.deck_skirting, null) > -1
            : _vm.values.options.deck_skirting,
        },
        on: {
          change: function ($event) {
            var $$a = _vm.values.options.deck_skirting,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 &&
                  _vm.$set(
                    _vm.values.options,
                    "deck_skirting",
                    $$a.concat([$$v])
                  )
              } else {
                $$i > -1 &&
                  _vm.$set(
                    _vm.values.options,
                    "deck_skirting",
                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                  )
              }
            } else {
              _vm.$set(_vm.values.options, "deck_skirting", $$c)
            }
          },
        },
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "option option--checkbox",
          attrs: { for: "deck_option_3" },
        },
        [
          _c("span", { staticClass: "center" }, [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.fields.deck_options.deck_skirting.title)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "description" }, [
              _vm._v(_vm._s(_vm.fields.deck_options.deck_skirting.description)),
            ]),
          ]),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: _vm.fields.deck_options.deck_skirting.image,
              alt: _vm.fields.deck_options.deck_skirting.title,
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.values.options.removal_of_existing_deck,
            expression: "values.options.removal_of_existing_deck",
          },
        ],
        staticStyle: { display: "none" },
        attrs: { type: "checkbox", id: "deck_option_4" },
        domProps: {
          checked: Array.isArray(_vm.values.options.removal_of_existing_deck)
            ? _vm._i(_vm.values.options.removal_of_existing_deck, null) > -1
            : _vm.values.options.removal_of_existing_deck,
        },
        on: {
          change: function ($event) {
            var $$a = _vm.values.options.removal_of_existing_deck,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 &&
                  _vm.$set(
                    _vm.values.options,
                    "removal_of_existing_deck",
                    $$a.concat([$$v])
                  )
              } else {
                $$i > -1 &&
                  _vm.$set(
                    _vm.values.options,
                    "removal_of_existing_deck",
                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                  )
              }
            } else {
              _vm.$set(_vm.values.options, "removal_of_existing_deck", $$c)
            }
          },
        },
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "option option--checkbox",
          attrs: { for: "deck_option_4" },
        },
        [
          _c("span", { staticClass: "center" }, [
            _c("span", { staticClass: "title" }, [
              _vm._v(
                _vm._s(_vm.fields.deck_options.removal_of_existing_deck.title)
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "description" }, [
              _vm._v(
                _vm._s(
                  _vm.fields.deck_options.removal_of_existing_deck.description
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: _vm.fields.deck_options.removal_of_existing_deck.image,
              alt: _vm.fields.deck_options.removal_of_existing_deck.title,
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.values.options.deck_fascias,
            expression: "values.options.deck_fascias",
          },
        ],
        staticStyle: { display: "none" },
        attrs: { type: "checkbox", id: "deck_option_5" },
        domProps: {
          checked: Array.isArray(_vm.values.options.deck_fascias)
            ? _vm._i(_vm.values.options.deck_fascias, null) > -1
            : _vm.values.options.deck_fascias,
        },
        on: {
          change: function ($event) {
            var $$a = _vm.values.options.deck_fascias,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 &&
                  _vm.$set(
                    _vm.values.options,
                    "deck_fascias",
                    $$a.concat([$$v])
                  )
              } else {
                $$i > -1 &&
                  _vm.$set(
                    _vm.values.options,
                    "deck_fascias",
                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                  )
              }
            } else {
              _vm.$set(_vm.values.options, "deck_fascias", $$c)
            }
          },
        },
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "option option--checkbox",
          attrs: { for: "deck_option_5" },
        },
        [
          _c("span", { staticClass: "center" }, [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.fields.deck_options.deck_fascias.title)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "description" }, [
              _vm._v(_vm._s(_vm.fields.deck_options.deck_fascias.description)),
            ]),
          ]),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: _vm.fields.deck_options.deck_fascias.image,
              alt: _vm.fields.deck_options.deck_fascias.title,
            },
          }),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "bottom font-h6" }, [
      _vm.costs_platform
        ? _c("div", [
            _vm._v(
              "Deck Platform: $" +
                _vm._s(Intl.NumberFormat("fr-FR").format(_vm.costs_platform))
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.costs_elevation
        ? _c("div", [
            _vm._v(
              "Elevation: $" +
                _vm._s(Intl.NumberFormat("fr-FR").format(_vm.costs_elevation))
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.costs_railing
        ? _c("div", [
            _vm._v(
              "Railing: $" +
                _vm._s(Intl.NumberFormat("fr-FR").format(_vm.costs_railing))
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.costs_privacy_wall
        ? _c("div", [
            _vm._v(
              "Privacy Wall: $" +
                _vm._s(
                  Intl.NumberFormat("fr-FR").format(_vm.costs_privacy_wall)
                )
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.costs_stairs
        ? _c("div", [
            _vm._v(
              "Stairs: $" +
                _vm._s(Intl.NumberFormat("fr-FR").format(_vm.costs_stairs))
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.costs_option_deck_permit
        ? _c("div", [
            _vm._v(
              "Deck Permit: $" +
                _vm._s(
                  Intl.NumberFormat("fr-FR").format(
                    _vm.costs_option_deck_permit
                  )
                )
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.costs_option_basic_lights_package
        ? _c("div", [
            _vm._v(
              "Basic Lights Package: $" +
                _vm._s(
                  Intl.NumberFormat("fr-FR").format(
                    _vm.costs_option_basic_lights_package
                  )
                )
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.costs_option_deck_skirting
        ? _c("div", [
            _vm._v(
              "Deck Skirting: $" +
                _vm._s(
                  Intl.NumberFormat("fr-FR").format(
                    _vm.costs_option_deck_skirting
                  )
                )
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.costs_option_removal_of_existing_deck
        ? _c("div", [
            _vm._v(
              "Removal Of Existing Deck: $" +
                _vm._s(
                  Intl.NumberFormat("fr-FR").format(
                    _vm.costs_option_removal_of_existing_deck
                  )
                )
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.costs_option_deck_fascias
        ? _c("div", [
            _vm._v(
              "Deck Fascias: $" +
                _vm._s(
                  Intl.NumberFormat("fr-FR").format(
                    _vm.costs_option_deck_fascias
                  )
                )
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "total font-h4" }, [
        _vm._v(
          "Total cost: $" +
            _vm._s(Intl.NumberFormat("fr-FR").format(_vm.costs_total))
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "button-order-wrapper" }, [
      _c("button", { staticClass: "button", on: { click: _vm.open_modal } }, [
        _vm._v("Send to Sales"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { ref: "floating", staticClass: "total-floating" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "total font-h6" }, [
          _vm._v(
            "Total cost: $" +
              _vm._s(Intl.NumberFormat("fr-FR").format(_vm.costs_total))
          ),
        ]),
        _vm._v(" "),
        _c("button", { staticClass: "button", on: { click: _vm.open_modal } }, [
          _vm._v("Send to Sales"),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "modal",
        staticClass: "modal modal--center modal--sm",
        attrs: { id: "modal-calculator-form" },
      },
      [
        _c("div", { staticClass: "modal-outer" }, [
          _c("div", { staticClass: "modal-inner" }, [
            _c("button", { staticClass: "close", attrs: { "data-close": "" } }),
            _vm._v(" "),
            _c("div", { staticClass: "modal-calculator-form" }, [
              _c("h3", { staticClass: "font-h4" }, [
                _vm._v("Fill out your contact details and we will contact you"),
              ]),
              _vm._v(" "),
              _c("form", { attrs: { action: "" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.first_name,
                      expression: "form.first_name",
                    },
                  ],
                  attrs: { type: "text", placeholder: "First Name" },
                  domProps: { value: _vm.form.first_name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "first_name", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.last_name,
                      expression: "form.last_name",
                    },
                  ],
                  attrs: { type: "text", placeholder: "Last Name" },
                  domProps: { value: _vm.form.last_name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "last_name", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.phone,
                      expression: "form.phone",
                    },
                  ],
                  attrs: { type: "text", placeholder: "Phone" },
                  domProps: { value: _vm.form.phone },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "phone", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.email,
                      expression: "form.email",
                    },
                  ],
                  attrs: { type: "text", placeholder: "Email" },
                  domProps: { value: _vm.form.email },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "email", $event.target.value)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  ref: "submit",
                  staticClass: "button",
                  on: { click: _vm.submit },
                },
                [_vm._v("Send")]
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }